export const siteName = "漫画e站";

export const hotTopics = [
  {
    id: 1,
    tag: "新番热议",
    title: "《月下长街》第 47 话迎来惊天反转，评论区吵翻了",
    excerpt:
      "深夜的旧巷、会说话的纸伞、以及那句被删掉的约定——本周更新让读者集体破防，争议与好评各占半壁江山。",
    likes: 3280,
    comments: 2146,
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20ink%20painting%20illustration%20of%20a%20moonlit%20ancient%20street%20alley%20at%20night%20with%20warm%20lantern%20lights%2C%20silhouette%20of%20a%20figure%20holding%20an%20umbrella%2C%20mysterious%20atmospheric%20mood%2C%20cream%20and%20amber%20color%20palette%2C%20manga%20story%20artwork&width=800&height=520&seq=topic-01&orientation=landscape",
    date: "2026-08-16",
  },
  {
    id: 2,
    tag: "补番指南",
    title: "被低估的冷门神作合集，99% 的人都没看过",
    excerpt:
      "不是所有好漫画都能被看见。这份冷门清单里的每一部，都是老读者私藏多年的心头好，适合想要跳出热榜的漫友。",
    likes: 5120,
    comments: 986,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20minimalist%20illustration%20of%20a%20cozy%20reading%20desk%20with%20stacked%20manga%20books%2C%20steaming%20tea%20cup%2C%20soft%20reading%20lamp%20glow%2C%20muted%20amber%20and%20cream%20tones%2C%20manga%20fan%20community%20artwork&width=800&height=520&seq=topic-02&orientation=landscape",
    date: "2026-08-14",
  },
  {
    id: 3,
    tag: "同人讨论",
    title: "《星火漫游者》作者专访：关于结局的三种解读",
    excerpt:
      "主创首次正面回应开放式结尾的争议，并透露剧场版的制作进度。资深读者也在评论区留下了自己的长篇解读。",
    likes: 2760,
    comments: 1560,
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20illustration%20of%20a%20space%20traveler%20watching%20colorful%20nebula%20and%20stars%20from%20a%20hillside%2C%20warm%20sunset%20glow%2C%20nostalgic%20mood%2C%20manga%20cover%20artwork%2C%20cream%20amber%20red%20palette&width=800&height=520&seq=topic-03&orientation=landscape",
    date: "2026-08-12",
  },
  {
    id: 4,
    tag: "避雷现场",
    title: "本期读者避雷实录：这 5 部连载口碑集体滑铁卢",
    excerpt:
      "热播榜不一定等于好口碑。整理近期讨论度最高的几部争议作品，帮你在开坑前做好心理建设。",
    likes: 4350,
    comments: 3210,
    cover:
      "https://readdy.ai/api/search-image?query=Playful%20illustration%20of%20warning%20signs%20and%20comic%20speech%20bubbles%20floating%20over%20a%20stack%20of%20manga%20volumes%2C%20warm%20muted%20colors%2C%20editorial%20manga%20community%20style&width=800&height=520&seq=topic-04&orientation=landscape",
    date: "2026-08-10",
  },
];

export const readerComments = [
  {
    id: 1,
    user: "追番到天亮",
    avatar: "https://readdy.ai/api/search-image?query=Simple%20flat%20illustration%20avatar%20of%20a%20cat%20wearing%20glasses%20reading%20a%20manga%2C%20warm%20orange%20background%2C%20cute%20minimal%20style&width=120&height=120&seq=avt-01&orientation=squarish",
    time: "2 小时前",
    topic: "《月下长街》第 47 话",
    text: "我前 40 话追得有多认真，这一话就被刀得有多狠。作者你是真的狠心，那把伞上写的字我放大了三遍才敢确认……",
    likes: 892,
    level: "骨灰级书友",
  },
  {
    id: 2,
    user: "墨鱼干炒饭",
    avatar: "https://readdy.ai/api/search-image?query=Simple%20flat%20illustration%20avatar%20of%20a%20smiling%20octopus%20character%20holding%20a%20pen%2C%20warm%20amber%20background%2C%20cute%20minimal%20style&width=120&height=120&seq=avt-02&orientation=squarish",
    time: "5 小时前",
    topic: "被低估的冷门神作合集",
    text: "感谢整理！里面有两部我追了五年都没舍得安利的，居然在这里见到同好，差点原地转圈。建议再出一个姊妹篇。",
    likes: 641,
    level: "资深漫友",
  },
  {
    id: 3,
    user: "不吃辣的阿岚",
    avatar: "https://readdy.ai/api/search-image?query=Simple%20flat%20illustration%20avatar%20of%20a%20fox%20character%20with%20warm%20smile%2C%20soft%20cream%20background%2C%20cute%20minimal%20style&width=120&height=120&seq=avt-03&orientation=squarish",
    time: "昨天",
    topic: "本期读者避雷实录",
    text: "前两部我是真在追，看到这条属实心梗。但也是真话，剧情从 30 话开始明显注水，编剧快醒醒！",
    likes: 527,
    level: "热心观众",
  },
  {
    id: 4,
    user: "碳水后置",
    avatar: "https://readdy.ai/api/search-image?query=Simple%20flat%20illustration%20avatar%20of%20a%20round%20panda%20character%20eating%20snacks%20while%20reading%2C%20warm%20tones%2C%20cute%20minimal%20style&width=120&height=120&seq=avt-04&orientation=squarish",
    time: "昨天",
    topic: "《星火漫游者》结局解读",
    text: "那个开放式结尾我觉得是故意的，把镜头停在归途的门槛上，作者要的就是「没说完的话」这件事本身。评论区解读看得我直起鸡皮疙瘩。",
    likes: 1034,
    level: "骨灰级书友",
  },
  {
    id: 5,
    user: "南巷旧书店",
    avatar: "https://readdy.ai/api/search-image?query=Simple%20flat%20illustration%20avatar%20of%20an%20owl%20character%20reading%20under%20a%20lamp%2C%20warm%20brown%20background%2C%20cute%20minimal%20style&width=120&height=120&seq=avt-05&orientation=squarish",
    time: "3 天前",
    topic: "冷门神作补番指南",
    text: "那部讲小城旧书店的真的绝，没有打斗没有奇幻，纯粹靠日常和对话撑起一片天，反而比很多大制作更耐看。",
    likes: 415,
    level: "资深漫友",
  },
];

export const rankData = [
  { id: 1, rank: 1, title: "月下长街", score: 9.7, votes: 18240, genre: "奇幻 · 治愈", change: "up", tag: "周更" },
  { id: 2, rank: 2, title: "星火漫游者", score: 9.5, votes: 15760, genre: "科幻 · 冒险", change: "up", tag: "完结" },
  { id: 3, rank: 3, title: "旧书店的午后", score: 9.4, votes: 10230, genre: "日常 · 治愈", change: "flat", tag: "连载" },
  { id: 4, rank: 4, title: "雾都侦探社", score: 9.2, votes: 9880, genre: "推理 · 悬疑", change: "down", tag: "周更" },
  { id: 5, rank: 5, title: "山海食堂", score: 9.1, votes: 8420, genre: "美食 · 奇幻", change: "up", tag: "连载" },
  { id: 6, rank: 6, title: "铃兰花开时", score: 8.9, votes: 7650, genre: "青春 · 恋爱", change: "flat", tag: "完结" },
  { id: 7, rank: 7, title: "夜航信号", score: 8.8, votes: 6130, genre: "科幻 · 悬疑", change: "up", tag: "月更" },
  { id: 8, rank: 8, title: "竹林琴声", score: 8.7, votes: 5870, genre: "古风 · 人文", change: "down", tag: "连载" },
];

export const booklists = [
  {
    id: 1,
    title: "入坑必读 · 治愈系十选",
    desc: "工作再累，也要留一盏灯给温柔的故事。这十部治愈系漫画，献给需要被好好抱抱的你。",
    count: 10,
    cover:
      "https://readdy.ai/api/search-image?query=Stack%20of%20cozy%20manga%20volumes%20with%20warm%20illustrations%2C%20a%20cup%20of%20tea%20and%20small%20plants%20on%20a%20soft%20blanket%2C%20warm%20cream%20amber%20tones%2C%20manga%20recommendation%20artwork&width=600&height=800&seq=book-01&orientation=portrait",
    tag: "治愈 · 新手友好",
    rating: 9.3,
    updated: "2026-08-15",
  },
  {
    id: 2,
    title: "烧脑推理 · 高能反转合集",
    desc: "每一话都在打破你的猜测。给喜欢动脑的漫友准备的推理盛宴，反转密度高到需要暂停消化。",
    count: 8,
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20illustration%20of%20a%20detective%20desk%20with%20magnifying%20glass%2C%20old%20case%20files%20and%20city%20silhouette%20at%20night%2C%20warm%20dramatic%20lighting%2C%20manga%20mystery%20artwork&width=600&height=800&seq=book-02&orientation=portrait",
    tag: "推理 · 高能",
    rating: 9.1,
    updated: "2026-08-12",
  },
  {
    id: 3,
    title: "冷门宝藏 · 小众神作清单",
    desc: "不逐热榜，只追真心。这份清单收录了被严重低估的作品，每一部都值得一个被看见的机会。",
    count: 12,
    cover:
      "https://readdy.ai/api/search-image?query=A%20hidden%20gem%20bookstore%20shelf%20glowing%20with%20warm%20light%2C%20old%20manga%20volumes%20and%20sparkling%20dust%20particles%2C%20cozy%20nostalgic%20atmosphere%2C%20warm%20amber%20tones%2C%20illustration&width=600&height=800&seq=book-03&orientation=portrait",
    tag: "冷门 · 宝藏",
    rating: 9.0,
    updated: "2026-08-08",
  },
  {
    id: 4,
    title: "热血少年 · 燃向精选",
    desc: "友情、梦想与永不熄灭的斗志。适合在低落时打开，让热血重新填满胸膛的燃系精选。",
    count: 9,
    cover:
      "https://readdy.ai/api/search-image?query=Energetic%20manga%20illustration%20of%20a%20hero%20rising%20against%20a%20flame%20and%20wind%20backdrop%2C%20warm%20orange%20red%20palette%2C%20dynamic%20shonen%20energy%2C%20artwork&width=600&height=800&seq=book-04&orientation=portrait",
    tag: "热血 · 燃向",
    rating: 9.2,
    updated: "2026-08-05",
  },
];

export const faqs = [
  {
    q: "漫画e站评分排行是怎么来的？",
    a: "评分排行由注册漫友对单部作品的综合打分实时汇总而成，参考剧情、画工、人设与更新质量四个维度，并会对明显刷分行为进行剔除，力求还原真实口碑。",
  },
  {
    q: "评论区里的读者吐槽会删减吗？",
    a: "评论区坚持「真实表达、理性交流」的原则，正常吐槽与讨论都会被保留。只有涉及人身攻击、剧透刷屏或广告营销的内容会被平台规则自动过滤。",
  },
  {
    q: "推荐书单多久更新一次？",
    a: "专题书单每周更新，会结合当季热番、完结口碑与读者反馈不断扩充。每份书单都附有简介与适合人群，方便快速判断是否合口味。",
  },
  {
    q: "如何参与话题讨论与同好交流？",
    a: "任何漫友都可以在话题页发表看法、点赞与收藏。新注册用户建议先完善昵称和偏好标签，系统会据此为你推荐更合拍的同好与讨论区。",
  },
  {
    q: "热门话题里的信息准确吗？",
    a: "话题内容以作品更新动态、官方消息与读者共创为基础整理，发布前会交叉核对来源。涉及剧透与传言的内容会特别标注，供你自行判断。",
  },
];

export const navSections = [
  { name: "热门话题", key: "topic" },
  { name: "读者吐槽", key: "community" },
  { name: "评分排行", key: "rank" },
  { name: "推荐书单", key: "booklist" },
  { name: "关于我们", key: "about" },
];